import React, { useState, useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';

const ExpenseAmount = (props) => {
    const {
        disabled,
        index,
        expense,
        originalExpense,
        originalExpenseEntries,
        isReimbursement,
        mode,
        isPosted,
        isPendingSubmission,
        isAnyExpensePosted,
        isViewOnly,
        isCreditCardTransaction = false,
        enableEditByCorrection = false,
    } = props;
    const { control, errors, setValue, watch } = useFormContext();
    const watchExpenseEntries = watch('expenseEntries');
    const [required, setRequired] = useState({
        required:
            expense?.status !== ExpenseStatusValuesEnum.NonReimbursable &&
            expense?.status !== ExpenseStatusValuesEnum.Abandoned,
    });

    useEffect(() => {
        setRequired({
            required:
                expense?.status !== ExpenseStatusValuesEnum.NonReimbursable &&
                expense?.status !== ExpenseStatusValuesEnum.Abandoned &&
                (mode !== 'cc' || expense?.status === ExpenseStatusValuesEnum.Approved),
        });
    }, [expense?.status]);

    const watchAmount = watch(`expenseEntries[${index}].amount`);
    const watchCurrency = watch(`expenseEntries[${index}].currency`);

    const disableByCCAsCorrectionOrStatus =
        (isCreditCardTransaction && expense?.status === ExpenseStatusValuesEnum.Approved) ||
        (isCreditCardTransaction && expense?.status === ExpenseStatusValuesEnum.Posted) ||
        (isCreditCardTransaction && expense?.previousVersionID);

    useEffect(() => {
        if (isReimbursement) {
            for (let indexLoop = 0; indexLoop < watchExpenseEntries.length; ++indexLoop) {
                if (indexLoop !== index) {
                    // If its not my amount
                    let originalForPage = null;
                    if (
                        originalExpenseEntries &&
                        originalExpenseEntries.length > 0 &&
                        watchExpenseEntries[indexLoop].id &&
                        watchExpenseEntries[indexLoop].id > 0
                    ) {
                        originalForPage = originalExpenseEntries.find(
                            (entry) => entry.id === watchExpenseEntries[indexLoop].id
                        );
                    }
                    if (
                        !originalExpenseEntries ||
                        !originalForPage ||
                        (originalForPage && originalForPage.status !== 'Posted')
                    ) {
                        // If the other tab original db expense is not posted update
                        if (watchExpenseEntries[indexLoop].amount !== watchAmount) {
                            setValue(`expenseEntries[${indexLoop}].amount`, watchAmount);
                        }
                    }
                }
            }
        }
    }, [watchAmount, setValue]);

    useEffect(() => {
        if (isReimbursement) {
            for (let indexLoop = 0; indexLoop < watchExpenseEntries.length; ++indexLoop) {
                if (indexLoop !== index) {
                    // If its not my currency
                    let originalForPage = null;
                    if (
                        originalExpenseEntries &&
                        originalExpenseEntries.length > 0 &&
                        watchExpenseEntries[indexLoop].id &&
                        watchExpenseEntries[indexLoop].id > 0
                    ) {
                        originalForPage = originalExpenseEntries.find(
                            (entry) => entry.id === watchExpenseEntries[indexLoop].id
                        );
                    }
                    if (
                        !originalExpenseEntries ||
                        !originalForPage ||
                        (originalForPage && originalForPage.status !== 'Posted')
                    ) {
                        // If the other tab original db expense is not posted update
                        if (watchExpenseEntries[indexLoop].currency !== watchCurrency) {
                            setValue(`expenseEntries[${indexLoop}].currency`, watchCurrency);
                        }
                    }
                }
            }
        }
    }, [watchCurrency, setValue]);

    return (
        <Grid2 item size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].amount`}
                defaultValue={expense.amount}
                rules={{
                    required: required.required ? 'Expense amount is required' : false,
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        {...required}
                        placeholder="0.00"
                        id="expense-amount"
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        label={
                            isCreditCardTransaction ? 'Charge Amount' : 'Submitted expense amount'
                        }
                        endAdornment={
                            <AmountCurrencyInputAdornment
                                disabled={
                                    isViewOnly ||
                                    disabled ||
                                    (isPosted && isViewOnly) ||
                                    isPendingSubmission ||
                                    enableEditByCorrection ||
                                    disableByCCAsCorrectionOrStatus ||
                                    (!!expense.id && !isReimbursement) ||
                                    (isReimbursement && expense.source === 'Clinician') ||
                                    (isReimbursement && index > 0) ||
                                    (isReimbursement &&
                                        index === 0 &&
                                        expense.source === 'LtAssociate' &&
                                        isAnyExpensePosted) ||
                                    (isReimbursement &&
                                        index === 0 &&
                                        expense.source === 'LtAssociate' &&
                                        originalExpense &&
                                        !(
                                            originalExpense.status === 'NeedMoreInformation' ||
                                            originalExpense.status === 'InProcess' ||
                                            originalExpense.status === 'ReadyForReview' ||
                                            originalExpense.status === 'ReturnedByAccounting' ||
                                            originalExpense.status === 'TcApproved'
                                        ))
                                }
                                index={index}
                                currencyType={expense.currency}
                            />
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.amount)}
                        disabled={
                            isViewOnly ||
                            (isPosted && isViewOnly) ||
                            isPendingSubmission ||
                            enableEditByCorrection ||
                            disableByCCAsCorrectionOrStatus ||
                            (isReimbursement && expense.source === 'Clinician') ||
                            (isReimbursement && index > 0) ||
                            (isReimbursement &&
                                index === 0 &&
                                expense.source === 'LtAssociate' &&
                                isAnyExpensePosted) ||
                            (isReimbursement &&
                                index === 0 &&
                                expense.source === 'LtAssociate' &&
                                originalExpense &&
                                !(
                                    originalExpense.status === 'NeedMoreInformation' ||
                                    originalExpense.status === 'InProcess' ||
                                    originalExpense.status === 'ReadyForReview' ||
                                    originalExpense.status === 'ReturnedByAccounting' ||
                                    originalExpense.status === 'TcApproved'
                                ))
                        }
                        helperText={errors.expenseEntries?.[index]?.amount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default ExpenseAmount;
